import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineCheckInBaggagePolicies,
  combineJourneyElementCommons,
  combineJourneys,
  createJourney,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  defaultBoardingPassResult,
  frequentFlyerCardSV,
  frequentFlyerCardUX,
  journeys,
  noItemToPayError,
  returnedBoardingPassResult,
  returnedPDFBoardingPassResult,
  seatmap,
  sentBoardingPassResult,
} from '../../mock/data';
import {
  contactEmail,
  contactPhone,
  journeyTraveler,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';

const journeyWithFF = createJourney({
  template: {
    ...acceptedJourney,
    journeyElements: combineJourneyElementCommons([
      createJourneyElementCommon({
        template: {
          ...journeys[0].journeyElements[0],
          journeyElement: createJourneyElement({
            template: {
              ...journeys[0].journeyElements[0].journeyElement,
              frequentFlyerCard: frequentFlyerCardUX
            }
          })
        }
      })
    ]).items
  }
});

const contactPhoneDetails = contactPhone;
contactPhoneDetails.travelerIds = [journeyTraveler.id];
const contactEmailDetails = contactEmail;
contactEmailDetails.travelerIds = [journeyTraveler.id];
const CONTACTS = [contactPhoneDetails, {
  ...contactEmailDetails,
  address: 'tester@amadeus.com'
}];

/**
 * OW 1Journey
 * 1ADT
 * No baggage
 * FF added
 * Boarding Passes sent
 * Contact added
 */
export const ow1Journey1AdtFFBoardingPassRetrieve: MockMap = {
  addContactsToJourney: [createMockData(CONTACTS)],
  addFrequentFlyerCardToJourney: [
    createMockData(frequentFlyerCardSV),
    createMockData(frequentFlyerCardUX)
  ],
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [
    createMockDataWithResponse(returnedBoardingPassResult, 201),
    createMockDataWithResponse(defaultBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201),
    createMockDataWithResponse(returnedBoardingPassResult, 201),
    createMockDataWithResponse(defaultBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201),
    createMockDataWithResponse(returnedBoardingPassResult, 201),
    createMockDataWithResponse(sentBoardingPassResult, 201),
    createMockDataWithResponse(returnedBoardingPassResult, 201),
    createMockDataWithResponse(defaultBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201),
    createMockDataWithResponse(returnedBoardingPassResult, 201),
    createMockDataWithResponse(sentBoardingPassResult, 201),
    createMockDataWithResponse(returnedBoardingPassResult, 201),
    createMockDataWithResponse(defaultBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201),
    createMockDataWithResponse(returnedBoardingPassResult, 201),
    createMockDataWithResponse(defaultBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201),
    createMockDataWithResponse(sentBoardingPassResult, 201),
    createMockDataWithResponse(returnedBoardingPassResult, 201),
    createMockDataWithResponse(defaultBoardingPassResult, 201),
    createMockDataWithResponse(returnedPDFBoardingPassResult, 201)
  ],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [noItemToPayError])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)
  ],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse(combineJourneys([journeyWithFF]).items, 201)
  ],
  retrieveJourney: [
    createMockData(journeyWithFF)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
